document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cs-product-section]').forEach(function (root) {
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-for]'));
    var mainMedia = root.querySelector('.cs-product__main-media');

    function setActiveMedia(id) {
      mediaItems.forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-media-id') === id);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb-for') === id);
      });
    }

    // Thumbnail -> main media swap
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveMedia(thumb.getAttribute('data-thumb-for'));
      });
    });

    // Swipe left/right on the main image to move to next/previous image
    if (mainMedia && mediaItems.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchActive = false;

      function goToOffset(offset) {
        var currentIndex = mediaItems.findIndex(function (el) {
          return el.classList.contains('is-active');
        });
        if (currentIndex === -1) return;
        var nextIndex = currentIndex + offset;
        if (nextIndex < 0) nextIndex = mediaItems.length - 1;
        if (nextIndex >= mediaItems.length) nextIndex = 0;
        var nextId = mediaItems[nextIndex].getAttribute('data-media-id');
        setActiveMedia(nextId);
      }

      mainMedia.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, { passive: true });

      mainMedia.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) return;
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        var SWIPE_THRESHOLD = 40;
        if (Math.abs(deltaX) > SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
          goToOffset(deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });

      // Mouse drag support for desktop
      var mouseDownX = null;
      mainMedia.addEventListener('mousedown', function (e) {
        mouseDownX = e.clientX;
      });
      mainMedia.addEventListener('mouseup', function (e) {
        if (mouseDownX === null) return;
        var deltaX = e.clientX - mouseDownX;
        mouseDownX = null;
        var SWIPE_THRESHOLD = 40;
        if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
          goToOffset(deltaX < 0 ? 1 : -1);
        }
      });
      mainMedia.addEventListener('mouseleave', function () {
        mouseDownX = null;
      });
    }

    // Variant/offer radio -> update hidden id input + selected style
    var radios = root.querySelectorAll('[data-cs-variant-radio]');
    var hiddenInput = root.querySelector('[data-cs-variant-input]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (hiddenInput) hiddenInput.value = radio.value;
        root.querySelectorAll('.cs-product__offer').forEach(function (label) {
          label.classList.toggle('is-selected', label.contains(radio) === false ? false : radio.checked);
        });
      });
    });
  });

  // Sticky add-to-cart bar visibility + sync
  var stickyBar = document.querySelector('[data-cs-sticky-atc]');
  var mainForm = document.querySelector('#cs-product-form');
  if (stickyBar && mainForm) {
    var trigger = document.querySelector('.cs-product__add-to-cart');
    if (trigger) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(trigger);
    }

    var stickySubmit = stickyBar.querySelector('[data-cs-sticky-submit]');
    if (stickySubmit) {
      stickySubmit.addEventListener('click', function (e) {
        e.preventDefault();
        mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
      });
    }
  }
});
